import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import "./query.css";
import "../searchBar.css";
import * as SVGImages from "../../svg";

import * as api from "helper/helper";
import { buildNameWithId } from "helper/tools";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import { useAuthStore } from "../../../../store/store";
import { FaPlus } from "react-icons/fa6";
import { IoSaveOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";

import {
  defaultOperators,
  QueryBuilder,
  Rule,
  RuleComponents,
  RuleComponentsWithSubQuery,
  RuleGroupBodyComponents,
  RuleGroupHeaderComponents,
  useRule,
  ValueEditor,
  ValueSelector,
} from "react-querybuilder";
import { fieldsComision, fieldsGO, fieldsIgnorar } from "./fields";
import "react-querybuilder/dist/query-builder.css";
import "./styles.css";
import { nivelesDisponibles } from "./musicalInstruments";
import { useTimeout } from "../../hooks/useTimeout";

import { useAsyncOptionList } from "react-querybuilder/async";

const initialQuery = { combinator: "and", rules: [] };

// --- Constants / Mock Data ---
//const availableFields = ["user_id", "email", "status", "created_at"];
const operators = ["=", "!=", ">", "<", "LIKE"];

// Define translations for a specific language (e.g., Spanish)
const esTranslations = {
  /*addRule: { label: 'Añadir Regla', title: 'Añadir Regla' },
  addGroup: { label: 'Añadir Grupo', title: 'Añadir Grupo' },
  removeRule: { label: 'Eliminar', title: 'Eliminar Regla' },
  removeGroup: { label: 'Eliminar Grupo', title: 'Eliminar Grupo' },
  combinators: { title: 'Combinador' },
  combinatorAnd: { label: 'Y', title: 'Y' },
  combinatorOr: { label: 'O', title: 'O' },
  notToggle: { label: 'No', title: 'Inverter Este Grupo' }*/
};

const RowField = {
  Nivel: { key: "Nivel", name: "Nivel" },
  Asociado: { key: "Asociado", name: "Asociado" },
  /*Cliente: { key: "Cliente", name: "Cliente" },*/
  MetodoDePago: { key: "MetodoDePago", name: "Metodo De Pago" },
};

const LEVEL = {
  ZERO: 0,
  FIRST: 1,
};

const RowFieldArray = Object.keys(RowField);

//--
// 1. Define configuration fields
const fields = [
  { name: "firstName", label: "First Name", type: "string" },
  { name: "subquery_field", label: "SubQuery Component", type: "string" },
  {
    name: "subquery_field",
    label: "Favorite Color WOOT",
    valueEditorType: "select", // Signals to use a dropdown
    values: [
      { name: "red", label: "Red" },
      { name: "blue", label: "Blue" },
      { name: "green", label: "Green" },
    ],
  },
  {
    name: "niveles disponibles",
    label: "Niveles Disponibles",
    valueEditorType: "select", // Signals to use a dropdown
    values: [
      { name: "oro", label: "Oro" },
      { name: "plata", label: "Plata" },
      { name: "bronce", label: "Bronce" },
    ],
  },
];

const searchFetchData = async (text) => {
  const criteria = {
    isActivo: true,
    texto: text,
    page: 1,
    pageSize: 25,
  };

  const responseProductos = await api.searchProductos(criteria).catch((e) => {
    toast.error("Error al pedir producto.");
  });
  if (!responseProductos) return;

  const searchPaqueteCriteria = { nombre: text, page: 1, pageSize: 25 };
  const responsePaquetes = await api
    .searchPaquetes(searchPaqueteCriteria)
    .catch((e) => {
      toast.error("Error al pedir producto.");
    });
  if (!responseProductos) return;

  const prods = responseProductos.data.subset.map((item) => {
    return { ...item, kind: "prod" };
  });
  const paqs = responsePaquetes.data.subset.map((item) => {
    return { ...item, kind: "paq", cantidad: 10 };
  });

  const all = [...prods, ...paqs];

  //setProductos(all);
};

// 2. Custom Rule layout wrapper that inserts inputs precisely after the ValueEditor
const CustomRuleLayout = (props) => {
  const { rule, handleOnChange } = props;

  console.log("--< " + JSON.stringify(props));
  // Handler to update the secondary value inside ruleData
  const onAfterValueInputChange = (e) => {
    const updatedRuleData = {
      ...rule.ruleData,
      afterValueParam: e.target.value,
    };
    handleOnChange("ruleData", updatedRuleData);
  };

  return (
    <div
      className="custom-rule-row"
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      {/* 
        We use the default Rule rendering logic, but we can hook into ruleComponents 
        to isolate exactly where things render, or append elements down the flex row.
      */}
      <Rule
        {...props}
        ruleComponents={{
          // We intercept the valueEditor inside the rule chain
          ValueEditor: (valueEditorProps) => (
            <>
              {/* First, render the default value editor input */}
              <props.schema.controls.valueEditor {...valueEditorProps} />

              {/* 1. Render Drag Handle if applicable */}
              {props.schema.dragHandle}

              {/* 2. Render core rule inputs (Field, Operator, Value) */}
              {props.schema.controls.fieldSelector(props)}
              {props.schema.controls.operatorSelector(props)}
              {props.schema.controls.valueEditor(props)}

              {/* Second, immediately insert the new input field right after it */}
              {rule.field === "subquery_field" && (
                <input
                  type="text"
                  placeholder="Param after ValueEditor..."
                  value={rule.ruleData?.afterValueParam || ""}
                  onChange={onAfterValueInputChange}
                  className="rule-value custom-appended-input"
                  style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    backgroundColor: "#e6f7ff",
                    marginLeft: "4px",
                  }}
                />
              )}
            </>
          ),
        }}
      />
    </div>
  );
};

// 1. Create your custom Header Component
const CustomRuleGroupHeader = (props) => {
  // Access default components to keep standard functionality intact
  const {
    combinatorSelector: CombinatorSelector,
    addRuleAction: AddRuleAction,
    addGroupAction: AddGroupAction,
  } = props;

  // Local state for your new input element
  const [groupName, setGroupName] = useState("");

  return (
    <div
      className="custom-rulegroup-header"
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        padding: "5px",
      }}
    >
      {/* Standard controls */}
      <CombinatorSelector {...props} />

      {/* Your custom input element */}
      <input
        type="text"
        placeholder="Name this group..."
        value={groupName}
        onChange={(e) => setGroupName(e.target.value)}
        style={{
          padding: "4px 8px",
          borderRadius: "4px",
          border: "1px solid #ccc",
        }}
      />

      {/* Standard action buttons */}
      <AddRuleAction {...props} />
      <AddGroupAction {...props} />
    </div>
  );
};

///////----------------
// 1. The selector that handles typing, API calls, and displaying options
const AutoCompleteValueSelector2 = (props) => {
  const { clearTimers, addAlert } = useTimeout();
  const { options, isLoading } = useAsyncOptionList(props, {
    debounceTime: 400, // Delays API call until typing pauses for 400ms
    // Creates unique cache entries matching the specific field and current text query
    getCacheKey: (props) => `autocomplete-${props.rule?.field}-${props.value}`,
    // Triggers when the cached option list is unavailable
    loadOptionList: async (value, { ruleOrGroup }) => {
      // Avoid making API requests for empty or short search queries
      if (!value || value.length < 2) {
        clearTimers();
        return [];
      }

      //const newValues = JSON.parse(value);
      const isObject = typeof value === "object" && value !== null;
      const newValues = isObject ? value : JSON.parse(value);
      if (newValues.finished) return [];

      // Enforce a 500ms debounce delay using a promise
      // await new Promise((resolve) => setTimeout(resolve, 500));

      if (!newValues || (newValues.text?.length ?? 0) < 2) return [];

      /*    addAlert(() => {
            props.handleOnChange(value);
          });*/

      try {
        const fieldName = ruleOrGroup?.field;

        /*    const criteria = {
          isActivo: true,
          texto: newValues.text,
          page: 1,
          pageSize: 25,
        };

        const responseProductos = await api
          .searchProductos(criteria)
          .catch((e) => {
            toast.error("Error al pedir producto.");
          });
        if (!responseProductos) return;
*/
        //
        const criteria = {
          isActivo: true,
          texto: newValues.text,
          page: 1,
          pageSize: 25,
        };

        const responseAsociados = await api
          .searchAsociados(criteria)
          .catch((e) => {
            toast.error("Error al pedir asociados.");
          });
        //

        const data = responseAsociados.data.subset.map((item) => {
          //options={[{ nombre: "we", id: 234 }]}

          const text = buildNameWithId(item, item.numAsociado);

          return {
            id: item.id,
            label: text,
            name: item.id,
            //info: prod,
          };
        });
        //const response = await fetch(`/api/autocomplete?q=${encodeURIComponent(value)}&field=${fieldName}`);
        //const data = await response.json();

        // Must return string[], Option[], or OptionGroup[]
        // e.g., [{ name: 'us', label: 'United States' }]
        return data;
      } catch (error) {
        console.error("Failed fetching autocomplete options", error);
        return [];
      }
    },
  });

  //const newValues = props.value; // JSON.parse(props.value?.length === 0 ? "{}" : props.value);

  const isObject = typeof props.value === "object" && props.value !== null;
  const newValues = isObject ? props.value : JSON.parse(props.value);

  const showClearButton = newValues.finished && newValues.text.length > 0;

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <div className="d-flex" style={{ justifyContent: "end" }}>
        <input
          type="text"
          className={`${props.className} form-control`}
          value={newValues.text ?? ""}
          placeholder="Escribir para buscar..."
          onChange={(e) => {
            clearTimers();

            const value = e.target.value;

            props.handleOnChange(
              JSON.stringify({ ...newValues, text: value, finished: false }),
            );
            /*props.handleOnChange({
              ...newValues,
              text: value,
              finished: false,
            });*/
          }}
        />

        <div
          className="d-flex"
          style={{
            position: "absolute",
            height: "100%",

            alignItems: "center",
          }}
        >
          {isLoading && (
            <img
              alt=""
              src={SVGImages.LOADER_90RING}
              style={{
                width: "25px",
                height: "25px",
                // marginLeft: "5px",
              }}
            />
          )}
          <button
            style={{ background: "none", border: "none", width: "35px" }}
            onClick={(e) => {
              // clearInput();
              props.handleOnChange(
                JSON.stringify({ ...newValues, text: "", finished: true }),
              );
            }}
            className={`form-control-clear glyphicon glyphicon-remove form-control-feedback1 ${
              showClearButton ? "" : "hideButton"
            }`}
          >
            <IoMdClose />
          </button>
          <button
            type="submit"
            title="Search"
            style={{ background: "none", border: "none", width: "25px" }}
          >
            <i className="bi bi-search"></i>
          </button>
        </div>

        {/* <AutocompleteGo
        options={options}
        placeholder="Buscar asociado..."
        className={`form-select `}
        textRaw={props.value ?? ""}
        onInputChanged={(e) => {
          //formik.setFieldValue("sucursal", e);

          clearTimers();

          addAlert(() => {
            props.handleOnChange(e);
          });
          /*    clearTimers();

                    addAlert(() => {
                      //formik.setFieldValue("productoValue", e);
                    //  searchFetchData(e);
                    });* /
        }}
        readOnly={false}
      >
        <div className="valid-feedback">Looks good!</div>
        <div className="invalid-feedback">er</div>
      </AutocompleteGo>*/}
      </div>

      {/*isLoading && <span style={{ marginLeft: 8 }}>Loading...</span>*/}

      {/* Render the fetched options list if there are results */}
      {options.length > 0 && (
        <ul
          className="autocomplete-dropdown results-auto"
          style={{
            position: "absolute",
            zIndex: 100,
            background: "#fff",
            border: "1px solid #ccc",
            listStyle: "none",
            padding: 5,
            height: "200px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            overflowY: "auto",
            width: "100%",
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.name}
              onClick={() => {
                props.handleOnChange(
                  JSON.stringify({
                    ...newValues,
                    finished: true,
                    asociadoId: opt.id,
                    text: opt.label,
                  }),
                );

                //  ...newValues,
                //    props.handleOnChange(opt.name)}
              }}
              style={{
                cursor: "pointer",
                padding: "4px 8px",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
////-----
const PorcentajeField = (props) => {
  // 1. Unpack data safely. Fallback to an empty string if the rule value hasn't been initialized yet.
  const isObject = typeof props.value === "object" && props.value !== null;
  const mainSelectValue = isObject ? props.value.main : props.value || "";
  const extraInfoValue = isObject ? props.value.extraInfo : "";
  const porcentaje = isObject ? props.value.porcentaje : "";

  // 2. Intercept changes from the native <select> / MultiSelect editor
  const handleSelectChange = (newSelectedValue) => {
    props.handleOnChange({
      main: newSelectedValue,
      extraInfo: extraInfoValue,
    });
  };

  // 3. Intercept changes from your extra custom input field
  const handleExtraInputChange = (e) => {
    props.handleOnChange2(e.target.value);
  };

  const { field, operator, value, handleOnChange, type } = props;

  return (
    <div className="">
      <div className="input-group">
        <label className="input-group-text" htmlFor="inputGroupSelect01">
          Porcentaje:
        </label>
        <input
          type="text"
          className="form-control"
          id="inputGroupSelect01"
          placeholder="-"
          min={10}
          step={1}
          max={99}
          value={value}
          onChange={handleExtraInputChange}
          onBlur={(e) => {
            let value = Number.parseInt(e.currentTarget.value);
            if (Number.isNaN(value)) {
              e.target.value = "";
              return;
            }

            console.log(value);

            if (value > 35) {
              value = 35;
            } else if (value < 10) {
              value = 10;
            }

            e.target.value = value;

            handleExtraInputChange(e);
          }}
          disabled={false}
        />
        <span className="input-group-text">%</span>
      </div>
    </div>
  );
  /* return 
     (<div className="">       
     <label>REPODE</label>                              
                    <div className="input-group">
                        <label class="input-group-text" htmlFor="inputGroupSelect01">Porcentaje:</label>
                        <input
                        type="text"
                        className="form-control"
                        id="floatingInputGroup1"
                        placeholder="-"
                        min={10}
                        step={1}
                        max={99}
                        value={extraInfoValue}
                        onChange={handleExtraInputChange}
                              onBlur={(e) => {
                                    let value = Number.parseInt(e.currentTarget.value);
                                    if(isNaN(value)){
                                    e.target.value = "";
                                    }

                                    console.log(value);

                                    if(value > 35){
                                        value = 35;
                                    }
                                    else if(value < 10){
                                        value = 10;
                                    }

                                    e.target.value = value;
                                  }}
                        disabled={false}
                        />                
                        <span className="input-group-text">%</span>
                    </div>
                </div>);*/
};

// 2. Custom ValueEditor wrapper component
const CustomValueEditorSample = (props) => {
  // Apply autocomplete only to specific fields (e.g., 'company' or 'country')

  // 1. Fallback to primitive value if it isn't an object yet
  const currentObject =
    props.value && typeof props.value === "object"
      ? props.value
      : JSON.parse(props.value);
  //{ actualValue: "", x: 0, y: 0, z: 0, porcentaje: 10 };

  const handlePorcentajeChange = (selectedPrimitiveValue) => {
    const re = {
      ...currentObject,
      /*actualValue: selectedPrimitiveValue, // Assign selected primitive
        x: 10, // Statically assign or compute your custom parameters here
        y: 20,
        z: 30,*/
      porcentaje: selectedPrimitiveValue,
    };
    props.handleOnChange(re);
  };

  if (props.field === "asociados") {
    return (
      <>
        <ValueEditor
          {...props}
          selectorComponent={AutoCompleteValueSelector2}
        />
        <PorcentajeField
          {...props}
          value={currentObject.porcentaje} // Feed it just the string it expects
          handleOnChange2={handlePorcentajeChange} // Supply the object wrapper interceptor
        />
      </>
    );
  } else if (props.field === "niveles" || props.field === "metodosdepago") {
    let aValue = currentObject.nivelId;
    if (props.field === "metodosdepago") {
      aValue = currentObject.metodoDePagoId;
    }

    // 2. Intercept and format the value as an object before saving
    const handleSelectChange = (selectedPrimitiveValue) => {
      let go = {
        ...currentObject,
        /*x: 10, // Statically assign or compute your custom parameters here
        y: 20,
        z: 30,*/
      };

      if (props.field === "niveles") {
        go.nivelId = selectedPrimitiveValue; // Assign selected primitive}
      } else if (props.field === "metodosdepago") {
        go.metodoDePagoId = selectedPrimitiveValue; // Assign selected primitive}
      }

      props.handleOnChange(go);
      /*props.handleOnChange({
        ...currentObject,
        actualValue: selectedPrimitiveValue, // Assign selected primitive
        x: 10, // Statically assign or compute your custom parameters here
        y: 20,
        z: 30,
      });*/
    };

    return (
      <>
        <ValueEditor
          {...props}
          value={aValue} // Feed it just the string it expects
          handleOnChange={handleSelectChange} // Supply the object wrapper interceptor
        />
        <PorcentajeField
          {...props}
          value={currentObject.porcentaje} // Feed it just the string it expects
          handleOnChange2={handlePorcentajeChange} // Supply the object wrapper interceptor
        />
      </>
    );
  }

  // Fall back to standard text inputs/dropdowns for other fields
  return (
    <>
      <ValueEditor {...props} />
      <PorcentajeField {...props} />
    </>
  );
};

// 1. Create your custom text field component
const CustomValueEditor = (props) => {
  // Fall back to default editor for specific fields if needed
  /*if (props.field !== "category") {
      return <ValueEditor {...props} />;
    }*/

  const { clearTimers, addAlert } = useTimeout();

  // 1. Unpack data safely. Fallback to an empty string if the rule value hasn't been initialized yet.
  const isObject = typeof props.value === "object" && props.value !== null;
  const mainSelectValue = isObject ? props.value.main : props.value || "";
  const extraInfoValue = isObject ? props.value.extraInfo : "";

  // 2. Intercept changes from the native <select> / MultiSelect editor
  const handleSelectChange = (newSelectedValue) => {
    props.handleOnChange({
      main: newSelectedValue,
      extraInfo: extraInfoValue,
    });
  };

  // 3. Intercept changes from your extra custom input field
  const handleExtraInputChange = (e) => {
    props.handleOnChange({
      main: mainSelectValue,
      extraInfo: e.target.value,
    });
  };

  //return null;
  const { field, operator, value, handleOnChange, type } = props;

  if (props.field === "asociados") {
    return (
      <>
        {/**   <input 
             type="text" 
             placeholder="Search database inventory..." 
             onChange={async (e) => {
                const res = await fetch(`/api/search?q=${e.target.value}`);
                const options = await res.json();
                // Send selected unique identifier key back to query hook state structure
                props.handleOnChange(options[0]?.id);
             }} 
           />
           */}

        {field === "asociados" && (
          <>
            {/*<input
        type="date"
        value={value || ''}
        className="custom-date-picker"
        placeholder="WERWER"
        onChange={(e) => handleOnChange(e.target.value)}
     />*/}
            {
              <div className="d-flex gap-2">
                <AutocompleteGo
                  options={[{ nombre: "we", id: 234 }]}
                  placeholder="Buscar asociado..."
                  className={`form-select `}
                  onInputChanged={(e) => {
                    //formik.setFieldValue("sucursal", e);

                    clearTimers();

                    addAlert(() => {
                      //formik.setFieldValue("productoValue", e);
                      searchFetchData(e);
                    });
                  }}
                  readOnly={false}
                >
                  <div className="valid-feedback">Looks good!</div>
                  <div className="invalid-feedback">er</div>
                </AutocompleteGo>
                <div className="">
                  {/*    <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  step="1"
                                 value={extraInfoValue}
                        //onChange={handleExtraInputChange}
                        onChange={handleExtraInputChange}
                                  min={11}
                                  max={50}
                                  onBlur={(e) => {
                                    let value = Number.parseInt(e.currentTarget.value);

                                    console.log(value);

                                    if(value > 35){
                                        value = 35;
                                    }
                                    else if(value < 10){
                                        value = 10;
                                    }

                                    e.target.value = value;
                                  }}
                                  disabled={false}
                                />
                                <label htmlFor="floatingInputGroup1">Porcentaje</label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>*/}
                  <div className="input-group">
                    <label
                      class="input-group-text"
                      htmlFor="inputGroupSelect01"
                    >
                      Porcentaje:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInputGroup1"
                      placeholder="-"
                      min={10}
                      step={1}
                      max={99}
                      value={extraInfoValue}
                      onChange={handleExtraInputChange}
                      onBlur={(e) => {
                        let value = Number.parseInt(e.currentTarget.value);

                        console.log(value);

                        if (value > 35) {
                          value = 35;
                        } else if (value < 10) {
                          value = 10;
                        }

                        e.target.value = value;
                      }}
                      disabled={false}
                    />
                    <span className="input-group-text">%</span>
                  </div>
                </div>
              </div>
            }
          </>
        )}
      </>
    );
  }

  // Render a custom text input field for other rules
  return (
    <>
      <ValueEditor
        {...props}
        value={mainSelectValue}
        handleOnChange={handleSelectChange}
      />
      {/*<input
        type="text"
        value={props.value ?? ""}
        onChange={(e) => props.handleOnChange(e.target.value)}
        placeholder="Type value..."
      />*/}

      {/*<div className=" input-group">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGroup1"
                  placeholder="Username"
                  min={10}
                  step={1}
                  max={99}
                
                value={extraInfoValue}
        onChange={handleExtraInputChange}
                  disabled={false}
                />
                <label htmlFor="floatingInputGroup1">Porcentaje</label>
              </div>
              <span className="input-group-text">%</span>
            </div> */}
      <div className="">
        {/*    <div className="input-group mb-3">
                              <div className="form-floating">
                                <input
                                  type="number"
                                  className="form-control"
                                  id="floatingInputGroup1"
                                  placeholder="Username"
                                  step="1"
                                 value={extraInfoValue}
                        //onChange={handleExtraInputChange}
                        onChange={handleExtraInputChange}
                                  min={11}
                                  max={50}
                                  onBlur={(e) => {
                                    let value = Number.parseInt(e.currentTarget.value);

                                    console.log(value);

                                    if(value > 35){
                                        value = 35;
                                    }
                                    else if(value < 10){
                                        value = 10;
                                    }

                                    e.target.value = value;
                                  }}
                                  disabled={false}
                                />
                                <label htmlFor="floatingInputGroup1">Porcentaje</label>
                              </div>
                              <span className="input-group-text">%</span>
                            </div>*/}
        <div className="input-group">
          <label class="input-group-text" htmlFor="inputGroupSelect01">
            Porcentaje:
          </label>
          <input
            type="text"
            className="form-control"
            id="floatingInputGroup1"
            placeholder="-"
            min={10}
            step={1}
            max={99}
            value={extraInfoValue}
            onChange={handleExtraInputChange}
            onBlur={(e) => {
              let value = Number.parseInt(e.currentTarget.value);

              console.log(value);

              if (value > 35) {
                value = 35;
              } else if (value < 10) {
                value = 10;
              }

              e.target.value = value;
            }}
            disabled={false}
          />
          <span className="input-group-text">%</span>
        </div>
      </div>
    </>
  );
};

const CustomRule = (props) => {
  return (
    <div className={props.className}>
      {/* 1. Render Drag Handle if applicable */}
      {props.schema.dragHandle}

      {/* 2. Render core rule inputs (Field, Operator, Value) */}
      {props.schema.controls.fieldSelector(props)}
      {props.schema.controls.operatorSelector(props)}
      {props.schema.controls.valueEditor(props)}

      {/* 3. Render your custom input or extra elements HERE */}
      <input type="text" placeholder="Your input before delete" />

      {/* 4. Render the delete/remove button LAST */}
      {props.schema.controls.removeRuleAction(props)}
    </div>
  );
};

const CustomRule1 = (props) => {
  const r = useRule(props);

  if (r.rule.match)
    return (
      <div className="rule rule-hasSubQuery">
        <RuleComponentsWithSubQuery {...props} {...r} />
        <div className="">
          <div className="input-group">
            <label class="input-group-text" htmlFor="inputGroupSelect01">
              Porcentaje:2
            </label>
            <input
              type="text"
              className="form-control"
              id="floatingInputGroup1"
              placeholder="-"
              min={10}
              step={1}
              max={99}
              disabled={false}
            />
            <span className="input-group-text">%</span>
          </div>
        </div>
      </div>
    );

  return (
    <div className="rule queryBuilder-invalid">
      <RuleComponents {...props} {...r} />
    </div>
  );
};

const CustomGroupHeader = (props) => {
  // Use the depth level to identify parent vs nested subgroups
  const isRoot = props.path.length === 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {/* 1. Custom Added Metadata Row */}
      <div style={{ paddingBottom: "8px", color: "#666", fontSize: "12px" }}>
        <strong>
          {isRoot
            ? "Root Logic Filter"
            : `Sub-Filter Group (Level ${props.path.length})`}
        </strong>
      </div>

      {/* 2. Render Standard Header Controls Inline */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <RuleGroupHeaderComponents {...props} />
        <div className="input-group">
          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="floatingInputGroup1"
              placeholder="Username"
              min={10}
              step={1}
              max={99}
              disabled={false}
            />
            <label htmlFor="floatingInputGroup1">Porcentaje</label>
          </div>
          <span className="input-group-text">%</span>
        </div>
      </div>
    </div>
  );
};

const CustomGroupHeaderDECA = (props) => {
  // 1. Look for a rule property up the tree or if this header belongs to a subquery rule group
  // Subquery rule headers will contain the parent rule details or matchMode metadata
  const isMatchModeSubQuery =
    props.context?.isSubQuery ||
    !!props.ruleGroup.rules.some((r) => r.matchMode);

  return (
    <div
      className={isMatchModeSubQuery ? "subquery-header" : "standard-header"}
    >
      {/* Your custom header layout */}
      <span>
        {isMatchModeSubQuery
          ? "Subquery Group Header"
          : "Standard Group Header"}
      </span>
    </div>
  );
};

const CustomGroupHeaderDEMO = (props) => {
  // Use the depth level to identify parent vs nested subgroups
  const isRoot = props.path.length === 0;

  let good = props.context?.isSubqueryMode;
  /*if(props?.ruleGroup?.rules?.[0]?.match){
  good=true;
  }*/

  // 1. Look for a rule property up the tree or if this header belongs to a subquery rule group
  // Subquery rule headers will contain the parent rule details or matchMode metadata
  const isMatchModeSubQuery =
    props.context?.isSubQuery ||
    !!props.ruleGroup.rules.some((r) => r.matchMode);

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {/* 1. Custom Added Metadata Row */}
      <div style={{ paddingBottom: "8px", color: "#666", fontSize: "12px" }}>
        <strong>
          {isRoot
            ? "Root Logic Filter"
            : `Sub-Filter Group (Level ${props.path.length})`}
        </strong>
      </div>

      {/* 2. Render Standard Header Controls Inline */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <RuleGroupHeaderComponents {...props} />
        {good && (
          <div className="input-group">
            <span className="input-group-text">Porcentaje:</span>
            <input
              type="text"
              className="form-control"
              aria-label="Amount (to the nearest dollar)"
              style={{ width: "100px" }}
            />
            <span className="input-group-text">%</span>
          </div>
        )}

        <div
          className={
            isMatchModeSubQuery ? "subquery-header" : "standard-header"
          }
        >
          {/* Your custom header layout */}
          <span>
            {isMatchModeSubQuery
              ? "Subquery Group Header"
              : "Standard Group Header"}
          </span>
        </div>
      </div>
    </div>
  );
};

const CustomGroupBody = (props) => {
  // Hide body completely if there are no rules/groups to display
  if (!props.rules || props.rules.length === 0) {
    return (
      <div style={{ padding: "12px", color: "#999", fontStyle: "italic" }}>
        No filters applied yet. Click above to add a rule!
      </div>
    );
  }

  return (
    <div
      className="custom-body-wrapper"
      style={{
        borderLeft: "2px dashed #007bff",
        paddingLeft: "16px",
        marginTop: "10px",
      }}
    >
      {/* Renders the standard list of rules/subgroups automatically */}
      <RuleGroupBodyComponents {...props} />
    </div>
  );
};

// Example of a custom "Add Rule" button for the header
const CustomAddRuleButton = ({ label, handleOnClick }) => (
  <button onClick={handleOnClick} className="custom-btn">
    ⚡ {label}
  </button>
);

const DualValueEditor = (props) => {
  // Use "between" operator as the trigger for dual inputs
  //if (props.operator === 'between' || props.operator === 'notBetween') {
  if (props.field !== "category") {
    // Parse the value as an array, fallback to defaults
    const [val1, val2] = Array.isArray(props.value)
      ? props.value
      : (props.value ?? "").split(",");

    const handleValueChange = (index, newValue) => {
      const updatedValue =
        index === 0 ? [newValue, val2 ?? ""] : [val1 ?? "", newValue];

      // Update the rule state with the new array/string
      props.handleOnChange(updatedValue);
    };

    return (
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <input
          type="text"
          value={val1 ?? ""}
          placeholder="Min"
          onChange={(e) => handleValueChange(0, e.target.value)}
        />
        <span>and</span>
        <input
          type="text"
          value={val2 ?? ""}
          placeholder="Max"
          onChange={(e) => handleValueChange(1, e.target.value)}
        />
      </div>
    );
  }

  // Fallback to the default React Query Builder editor for other operators
  return <ValueEditor {...props} />; //<props.schema.controls.valueEditor {...props} />;
};

//OXXO
// 1. Define fields for the query builder
const fieldsOXXO = [
  { name: "firstName", label: "First Name", type: "string" },
  { name: "lastName", label: "Last Name", type: "string" },
  { name: "subquery_group", label: "SubQuery Component", type: "string" },

  {
    name: "niveles",
    label: "Nivel",
    valueEditorType: "select",
    values: nivelesDisponibles,
    // This must be commented out to properly demonstrate `autoSelectValue={false}`
    // defaultValue: 'Cowbell',
    operators: defaultOperators.filter(
      (op) => op.name === "=" || op.name === "!=",
    ),

    //field: "category"
  },
];

// 2. Custom Rule Component that appends our custom subquery input
const CustomRuleWithSubQueryInput = (props) => {
  const { rule, handleOnChange } = props;

  // Handler to update our custom field in ruleData
  const onSubQueryInputChange = (e) => {
    const updatedRuleData = {
      ...rule.ruleData,
      subQueryInputVal: e.target.value,
    };
    // Notify the builder of the state change
    handleOnChange("ruleData", updatedRuleData);
  };

  return (
    <div
      className="custom-rule-wrapper"
      style={{ display: "flex", alignItems: "center", gap: "8px" }}
    >
      {/* Render the standard Rule components (Field, Operator, Value) */}
      <Rule {...props} />

      {/* Render our extra input conditionally (e.g., only for our subquery field) */}
      {/*rule.field === 'subquery_group' && (. */}
      <div className="subquery-extra-input" style={{ marginLeft: "8px" }}>
        <input
          type="text"
          placeholder="Enter SubQuery param..."
          value={rule.ruleData?.subQueryInputVal || ""}
          onChange={onSubQueryInputChange}
          className="rule-value"
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      </div>
      {/**   )} */}
    </div>
  );
};

//OXXO

// Custom AddRuleAction component using a select dropdown
const CustomAddRuleSelect = ({ handleOnClick, ...props }) => {
  const handleChange = (event) => {
    const value = event.target.options[event.target.selectedIndex].text; //event.target.value;
    if (!value) return;

    // Trigger the appropriate action based on selection
    handleOnClick(event, value);

    // Reset selection back to placeholder
    event.target.value = "";
  };

  return (
    <label>
      Selecciona Regla:
      <select
        className="rule-add-select"
        defaultValue=""
        onChange={handleChange}
      >
        <option value="" disabled>
          {" "}
          + Tipo...
        </option>
        {fieldsGO.map((og) => {
          return (
            <option value="rule" key={og.label}>
              {og.label}
            </option>
          );
        })}
      </select>
    </label>
  );
};

const FilteredFieldSelector = (props) => {
  const filteredFields = fieldsGO.find((optGroup) =>
    optGroup.options.map((og) => og.name).includes(props.value),
  ).options;

  return <ValueSelector {...{ ...props, options: filteredFields }} />;
};

const CustomFieldSelector = (props) => {
  <select
    value={props.value}
    onChange={(e) => props.handleOnChange(e.target.value)}
  >
    {props.options.map((opt) => (
      <option key={opt.name} value={opt.name}>
        {opt.label}
      </option>
    ))}
  </select>;
};

const AddRuleButtons = (props) => (
  <>
    {fieldsGO
      .map((og) => og.label)
      .map((lbl) => (
        <button onClick={(e) => props.handleOnClick(e, lbl)}>
          +Rule ({lbl})
        </button>
      ))}
  </>
);

//const availableFieldsPro = ["Nivel", "Asociado", "Cliente", "Forma Pago"];

// Initial state: An array of clause objects
const initialQueryState = [];

// Helper function to generate a unique ID for each row
let nextId = 0;
const getNextId = () => `clause-${nextId++}`;

// ===============================
// CORE COMPONENT: QueryRow
// This component handles the logic and display for one single clause.
// ===============================
const QueryGroup = ({
  id,
  clause,
  onRemove,
  onChange,
  onUpdate,
  onUpdateAgregarGrupo,
  onNewGroup,
  className,
  asociados,
  niveles,
  metodosDePago,
  groupName = "-",
  parentLevel = 0,
  level = 0,
  initialClauses,
  enableAgregar = false,
  showAgregarRule = false,
  showAgregarGrupo = false,
}) => {
  const [clauses, setClauses] = useState([]);

  //const [asociadoSelected, setAsociadosSelected] = useState([]);

  useEffect(() => {
    if (initialClauses == null) {
      return;
    }
    //  setClauses([...clauses, { type: "rule", operator: "=", field: "" }]);
    setClauses(initialClauses);
  }, [initialClauses]);

  useEffect(() => {
    if (parentLevel === LEVEL.ZERO) {
      onUpdate?.(id, "field", RowField.Nivel.key);
      /*setClauses([
        ...clauses,
      ]);*/
    }
  }, [level]);

  const handleFieldChange = (e) => {
    onChange?.(id, "field", e.target.value);
  };

  const handleOperatorChange = (e) => {
    onChange(id, "operator", e.target.value);
  };

  const handleValueChange = (e) => {
    onChange(id, "value", e.target.value);
  };

  const handleAddRuleChange = (e) => {
    //  onChange(id, "rule");
    if (clauses.length === 0) return;

    const field = clauses[0].field;
    if (field === RowField.MetodoDePago.key) {
      e.showAgregarRule =
        metodosDePago?.length === 0
          ? true
          : clauses.length < metodosDePago?.length - 1;
      /*    asociados,
  niveles,
  metodosDePago,*/
    }

    let groupVisible = false;
    //let enableAgregar = false;
    if (field === RowField.Asociado.name) {
      groupVisible = true;
      //enableAgregar = true;
    }
    //else if (clauses.length === 2) {

    const newClauses = [
      ...clauses,
      {
        type: "rule",
        operator: "=",
        field: field,
        fieldVisible: false,
        groupVisible: groupVisible,
      },
    ];

    setClauses(newClauses);

    onNewGroup?.(newClauses);
  };

  const handleAddGroupChange = (e) => {
    //  onChange(id, "group");

    /*
    - asociado
    - forma pago
     */
    let key = "";
    let name = "";
    let groupVisible = false;
    let enableAgregar = false;
    let showAgregarGrupo = true;
    if (clauses.length === 1) {
      key = RowField.Asociado.key;
      name = RowField.Asociado.name;
      groupVisible = true;
      enableAgregar = true;
      showAgregarGrupo = false;
    } else if (clauses.length === 2) {
      key = RowField.MetodoDePago.key;
      name = RowField.MetodoDePago.name;
      showAgregarGrupo = false;
    }

    onUpdateAgregarGrupo?.(id, enableAgregar);

    const newClauses = [
      ...clauses,

      {
        id: getNextId(),
        field: "",
        operator: "=",
        value: "",
        type: "group",
        level: 1,
        groupName: name,
        fieldVisible: false,
        enableAgregar: enableAgregar,
        showAgregarRule: true,
        showAgregarGrupo: showAgregarGrupo,
        initialClauses: [
          {
            type: "rule",
            operator: "=",
            field: key,
            fieldVisible: false,
            groupVisible: groupVisible,
          },
        ],
      },

      /*{
        type: "group",
        groupName: "EO",
        level: 1,
        initialClauses: [{ type: "rule", operator: "=", field: "" }],
      },*/
    ];

    onNewGroup?.(newClauses);

    setClauses(newClauses);
  };

  // Helper function to render the input field based on the value/type
  const renderInput = (currentValue) => {
    return (
      <input
        type="text"
        className={`border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500`}
        value={currentValue}
        onChange={handleValueChange}
      />
    );
  };

  const showAgregar = enableAgregar ? "" : "disabled";

  return (
    <div
      className={` items-center space-x-4 py-3 px-4 bg-gray-50 border-b  border border-1 border-primary rules-group-container d-flex flex-column`}
    >
      {/* Field Selector */}
      <div
        className="rules-group-header  d-flex flex-row gap-2"
        style={{ flex: "1" }}
      >
        <div className="btn-group group-conditions d-flex align-items-center">
          <span className="fw-bolder">{groupName}</span>
          {/*<label className="btn btn-xs btn-primary active disabled">
            <input
              type="radio"
              name="builder-widgets_group_0_cond"
              value="AND"
              disabled=""
            />{" "}
            OPCION 1
          </label>

          <span style={{ flex: "1" }} />

          <label className="btn btn-xs btn-primary disabled">
            <input
              type="radio"
              name="builder-widgets_group_0_cond"
              value="OR"
              disabled=""
            />{" "}
            OPCION 2
          </label>*/}
        </div>
        <span style={{ flex: "1" }} />
        <div className="btn-group pull-right group-actions">
          {showAgregarRule && (
            <button
              type="button"
              className="btn btn-xs btn-sm btn-success"
              data-add="rule"
              onClick={() => handleAddRuleChange(clause)}
            >
              <FaPlus /> Agregar Regla
            </button>
          )}
          {showAgregarGrupo && (
            <button
              type="button"
              className={`btn btn-xs btn-sm btn-success ${showAgregar}`}
              data-add="group"
              onClick={() => handleAddGroupChange(id)}
            >
              <FaPlus /> Agregar Grupo 55
            </button>
          )}
        </div>

        <div className="error-container" data-toggle="tooltip">
          <i className="glyphicon glyphicon-warning-sign"></i>
        </div>
      </div>

      <div className="rules-group-body">
        <div className="rules-list">
          {clauses.map((clause, index) => {
            if (clause.type === "group") {
              return (
                <QueryGroup
                  key={clause.id}
                  id={clause.id}
                  clause={clause}
                  asociados={asociados}
                  niveles={niveles}
                  metodosDePago={metodosDePago}
                  groupName={clause.groupName}
                  level={clause.level}
                  enableAgregar={clause.enableAgregar}
                  initialClauses={clause.initialClauses}
                  showAgregarGrupo={clause.showAgregarGrupo}
                  showAgregarRule={clause.showAgregarRule}
                  onNewGroup={(newClauses) => {
                    clause.newGroup = newClauses;
                  }}
                />
              );
            }

            return (
              <QueryRule
                key={clause.id}
                clause={clause}
                asociados={asociados}
                niveles={niveles}
                metodosDePago={metodosDePago}
                onPorcentajeChange={(id, field, value) => {
                  clause.valueDescuento = value;
                }}
                onChange={(idRule, typeRule, infoTypeRule, other) => {
                  console.log(
                    clause + " " + id + " " + typeRule + " " + infoTypeRule,
                  );
                  clause.field = infoTypeRule.key;
                  clause.fieldName = infoTypeRule.name;

                  if (typeRule.key === RowField.Asociado.key) {
                    clause.asociadoSelected = other.id;
                  }

                  setClauses([...clauses]);

                  // mandar a padre de grupo para nombrar grupo
                  //**onUpdate(id, infoTypeRule, infoTypeRule.name);
                }}
                onNivelChange={(id, field, value) => {
                  // onNivelChange?.(id, field, e.target.value);
                  console.log("--->");

                  //  console.log(clause + " " + id + " " + type + " " + infoType);
                  clause.valueId = value;
                  setClauses([...clauses]);
                }}
                onAsociadoChange={(id, field, value) => {
                  // onNivelChange?.(id, field, e.target.value);
                  console.log("--->");

                  //  console.log(clause + " " + id + " " + type + " " + infoType);
                  clause.valueId = value;
                  setClauses([...clauses]);
                }}
                onMetodoDePagoChange={(id, field, value) => {
                  // onNivelChange?.(id, field, e.target.value);
                  console.log("--->");

                  //  console.log(clause + " " + id + " " + type + " " + infoType);
                  clause.valueId = value;
                  setClauses([...clauses]);
                }}
                onDelete={(id, field, value) => {
                  // onNivelChange?.(id, field, e.target.value);
                  console.log("--->");

                  //  console.log(clause + " " + id + " " + type + " " + infoType);
                  const foundIndex = clauses.indexOf(clause);
                  if (foundIndex === -1) {
                    return;
                  }

                  let newClauses = clauses.slice(foundIndex, 1);

                  setClauses([...newClauses]);
                }}
                onNewGroup={(newClauses) => {
                  clause.insideGroup = newClauses;
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

const QueryRule = ({
  id,
  clause,
  onRemove,
  onChange,
  onNivelChange,
  onMetodoDePagoChange,
  onPorcentajeChange,
  onAsociadoChange,
  onNewGroup,
  onDelete,
  className,
  asociados,
  niveles,
  metodosDePago,
}) => {
  const handleFieldChange = (e) => {
    const value = e.target.value;
    const rowField = RowFieldArray.find((rowField) => {
      const field = RowField[rowField];
      return field.key === value;
    });

    if (rowField == null) {
      return;
    }

    onChange?.(id, "field", RowField[rowField]);
  };

  const handleNivelChange = (e, field) => {
    onNivelChange?.(id, field, e.target.value);
  };

  const handleAsociadoChanged = (e, field) => {
    //typeRule, infoTypeRule)
    //onChange?.(id, "field", RowField.Asociado, e);
    onAsociadoChange?.(id, field, e.id);
  };

  const handleClienteChanged = (e) => {
    onChange?.(id, "field", e.target.value);
  };

  const handleMetodoDePagoChanged = (e) => {
    onMetodoDePagoChange?.(id, "field", e.target.value);
  };

  const handlePorcentajeChanged = (e, value) => {
    onPorcentajeChange?.(id, "field", value);
  };

  const [asociadoSelected, setAsociadoSelected] = useState(null);
  //const [clienteSelected, setClienteSelected] = useState(null);
  //const [clientes, setClientes] = useState([]);
  const [valueDescuento, setValueDescuento] = useState(clause.porcentaje ?? 10);

  const [isLoading, setIsLoading] = useState(false);

  const refAutocompleteAsociados = useRef(null);
  const refAutocompleteClientes = useRef(null);

  const handleOperatorChange = (e) => {
    onChange(id, "operator", e.target.value);
  };

  const [clauses, setClauses] = useState([
    //  { type: "group", operator: "=", field: "" },
  ]);

  useEffect(() => {
    if (clause == null) return;

    setClauses(clause.initialClauses);
  }, [clause]);

  const handleValueChange = (e) => {
    onChange(id, "value", e.target.value);
  };

  const handleAddRuleChange = (e) => {
    //  onChange(id, "rule");

    setClauses([...clauses, { type: "rule" }]);
  };

  const handleAddGroupChange = (e) => {
    //  onChange(id, "group");
    if (clauses.length >= 0) {
      e.groupVisible = false;
    }
    const newClass = {
      id: "group.id",
      field: "",
      operator: "=",
      value: "",
      type: "group",
      level: 0,
      enableAgregar: true,
      showAgregarRule: true,
      showAgregarGrupo: false,
      groupName: RowField.MetodoDePago.name,
      initialClauses: [
        {
          type: "rule",
          operator: "=",
          field: RowField.MetodoDePago.key,
          fieldVisible: false,
        },
      ],
    };

    const newClauses = [...clauses, newClass];

    setClauses(newClauses);

    onNewGroup?.(newClass);
  };

  //
  const fetchClienteData = async (asociadoSelected) => {
    setIsLoading(true);

    ///---
    const criteria = {
      asociadoIds: [asociadoSelected],
    };
    /*  const response = await api.searchClientes(criteria).catch((error) => {
      toast.error("Error al buscar Clientes.");
      setIsLoading(false);
    });
    if (!response) return;*/
    /*
    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });*/

    //  setClientes(response.data.subset);

    //----

    /*  const responseNiveles = await api.clientes().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseNiveles) return;

    const autoNiveles = responseNiveles.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });*/

    //  setNiveles(autoNiveles);
    //
    /*  const response = await api
      .searchAsociados({ isActivo: true, page: 1, pageSize: "350" })
      .catch((e) => {
        toast.error("Error al pedir asociados.");
      });
    if (!response) return;

    const autoAsociados = response.data.subset.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);*/

    //

    /*let criteria = searchCriteria;
    if (resetPageNumber) {
      /// reset pag info
      store.pagingInfoRef.resetPageInfo();
    }

    //pagingInfoRef.current.resetPageInfo();

    criteria = store.pagingInfoRef.buildFetch(criteria);
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);*/
  };
  //

  const queryBuilderClientesResponse =
    useAuthStore.getState().queryBuilderClientesResponse;

  useEffect(() => {
    const clienteResponseHandle = useAuthStore.subscribe(
      (state) => state.queryBuilderClientesResponse,
      (value, prevValue) => {
        if (value && prevValue === false) {
          // TODO fix  setFireLogout(true);
          /*  setTimeout(() => {
                userLogout();
              }, 100);*/
          //  useAuthStore.setState({ inLogoutMode: false });
        }
      },
    );

    return () => {
      clienteResponseHandle();
    };
  }, []);

  useEffect(() => {
    /*if (asociadoSelected == null) {
      setClientes([]);
      setClienteSelected(null);
      return;
    }*/

    fetchClienteData(asociadoSelected);
  }, [asociadoSelected]);

  // Helper function to render the input field based on the value/type
  const renderInput = (currentValue) => {
    return (
      <input
        type="text"
        className={`border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500`}
        value={currentValue}
        onChange={handleValueChange}
      />
    );
  };

  //const precioEnPaquete = item.precioEnPaquete;
  /*const precioEnPaquete = 0;
  const errorPrecio = "";
  const precio = 45; */

  //  const minimoDescuento = 10;
  const shown = clause.fieldVisible ? "" : "d-none";
  const showGroupAgregar = clause.groupVisible ? "" : "d-none";

  return (
    <>
      <div
        id="builder-basic_rule_3"
        className="rule-container d-flex d-col flex-column"
      >
        <div className="d-flex flex-grow-1">
          <div className="rule-filter-container d-flex">
            <div className="d-flex gap-4 flex-row align-items-center ">
              <div className={shown}>
                <select
                  className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
                  value={clause.field}
                  onChange={handleFieldChange}
                >
                  <optgroup>
                    <option value="" selected disabled hidden>
                      Selecciona Campo
                    </option>
                    {RowFieldArray.map((rowField) => {
                      const field = RowField[rowField];

                      //    const shown = clause.fieldVisible ? "d-none" : "";

                      return (
                        <option key={field.key} value={field.key}>
                          {field.name}
                        </option>
                      );
                    })}
                  </optgroup>
                </select>
              </div>

              {/* Operator Selector * /}
            <div
              className="d-flex  align-items-center"
              style={{ alignItems: "center" }}
            >
              <select
                className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
                value={clause.operator}
                onChange={handleOperatorChange}
              >
                {operators.map((op) => (
                  <option key={op} value={op}>
                    {op}
                  </option>
                ))}
              </select>
            </div>*/}

              {clause.field === RowField.Nivel.key && (
                <div className="d-flex gap-4 flex-row align-items-center ">
                  <div>
                    <select
                      className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
                      value={clause.valueId}
                      onChange={(e) => {
                        handleNivelChange(e, clause.field);
                      }}
                    >
                      <option value="" disabled selected>
                        Selecciona un Nivel
                      </option>
                      {/*availableFields.map((field) => (
              <option key={field} value={field}>
                {field}
              </option>
            ))*/}
                      {niveles?.map((field) => (
                        <option key={field.id} value={field.id}>
                          {field.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {clause.field === RowField.MetodoDePago.key && (
                <div className="d-flex gap-4 flex-row align-items-center ">
                  <div>
                    <select
                      className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
                      value={clause.valueId}
                      onChange={(e) => {
                        handleMetodoDePagoChanged(e, clause.field);
                      }}
                    >
                      <optgroup>
                        <option value="" disabled selected>
                          Selecciona un Metodo de Pago
                        </option>
                        {metodosDePago?.map((field) => (
                          <option key={field.id} value={field.id}>
                            {field.nombre}
                          </option>
                        ))}
                      </optgroup>
                    </select>
                  </div>
                </div>
              )}

              {clause.field === RowField.Asociado.key && (
                <div className="">
                  <AutocompleteGo
                    ref={refAutocompleteAsociados}
                    options={asociados}
                    placeholder="Buscar asociado..."
                    className={`form-select `}
                    value={clause.asociadoSelected}
                    onChange={(e) => {
                      //formik.setFieldValue("sucursal", e);
                      console.log(e);

                      setAsociadoSelected(e?.id);

                      handleAsociadoChanged(e, clause.field);

                      /*  const id = e == null ? 0 : parseInt(e.id);
                        formik.setFieldValue("asociadoId", id);
                        asociadoIdRef.current = id;

                        setDisableCrearOrden(id === 0);
                        formik.setFieldValue("clienteId", 0);

                        validateOrder();

                        clientFetch(id);*/
                    }}
                    readOnly={false}
                  >
                    <div className="valid-feedback">Looks good!</div>
                    <div className="invalid-feedback">
                      {/*formik.errors.asociadoId*/}
                    </div>
                  </AutocompleteGo>
                </div>
              )}
            </div>
          </div>
          <div className="rule-operator-container"></div>
          <div className="rule-value-container"></div>

          <div className="col">
            <div className="input-group">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGroup1"
                  placeholder="Username"
                  min={10}
                  step={1}
                  max={99}
                  value={valueDescuento}
                  onChange={(event) => {
                    const rawInput = event.target.value;

                    // --- 1. PRE-PROCESSING & CLEANING ---
                    // Get the clean, numeric value from the user's input (removing formatting characters like commas/symbols)
                    let cleanedNumericValue = rawInput.replace(/[^\d]/g, "");
                    cleanedNumericValue = cleanedNumericValue.replace(
                      /^0+/,
                      "",
                    );

                    let rawNum = cleanedNumericValue;
                    // cut to only 3 integers
                    if (rawNum.length > 2) {
                      rawNum = cleanedNumericValue.slice(0, 3);
                    } else if (rawNum.length === 0) {
                      rawNum = "0";
                    }

                    setValueDescuento(rawNum);
                  }}
                  onBlur={(e) => {
                    let value = Number.parseFloat(e.currentTarget.value);

                    if (value < 10) {
                      value = 10;
                    } else if (value > 99) {
                      value = 99;
                    }

                    // aplicar margen
                    const margen = 45; //por mientras
                    if (value > margen) {
                      value = margen;
                    }

                    setValueDescuento(value);

                    handlePorcentajeChanged(clause.field, value);
                  }}
                  disabled={false}
                />
                <label htmlFor="floatingInputGroup1">Porcentaje</label>
              </div>
              <span className="input-group-text">%</span>
            </div>
          </div>

          <div className="error-container" data-toggle="tooltip">
            <i className="glyphicon glyphicon-warning-sign"></i>
          </div>

          <span style={{ flex: "1" }}></span>

          <div className="rule-header d-flex align-items-center">
            <div className="d-flex gap-1 pull-right rule-actions">
              <button
                type="button"
                className={`btn btn-xs btn-sm btn-success ${showGroupAgregar}`}
                data-add="group"
                onClick={() => handleAddGroupChange(clause)}
              >
                <FaPlus /> Agregar Grupo 999
              </button>

              <button
                type="button"
                className="btn btn-xs btn-sm btn-danger"
                data-delete="rule"
                onClick={(e) => {
                  onDelete?.(e, clause.field);
                }}
              >
                <i className="glyphicon glyphicon-remove"></i> Borrar
              </button>
            </div>
          </div>
        </div>
        <div className="">
          {clauses?.map((clause, index) => {
            return (
              <QueryGroup
                key={clause.id}
                id={clause.id}
                clause={clause}
                asociados={asociados}
                niveles={niveles}
                metodosDePago={metodosDePago}
                groupName={clause.groupName}
                level={clause.level}
                enableAgregar={clause.enableAgregar}
                initialClauses={clause.initialClauses}
                showAgregarGrupo={clause.showAgregarGrupo}
                showAgregarRule={clause.showAgregarRule}
                onNewGroup={(newClauses) => {
                  clause.newGroup = newClauses;
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

// ===============================
// CORE COMPONENT: QueryRow
// This component handles the logic and display for one single clause.
// ===============================
const QueryRow = ({ id, clause, onRemove, onChange, className }) => {
  const handleFieldChange = (e) => {
    onChange?.(id, "field", e.target.value);
  };

  const handleOperatorChange = (e) => {
    onChange(id, "operator", e.target.value);
  };

  const handleValueChange = (e) => {
    onChange(id, "value", e.target.value);
  };

  // Helper function to render the input field based on the value/type
  const renderInput = (currentValue) => {
    return (
      <input
        type="text"
        className={`border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500`}
        value={currentValue}
        onChange={handleValueChange}
      />
    );
  };

  if (clause.type) {
    return (
      <>
        <div className="rules-group-header">
          <div className="btn-group pull-right group-actions gap-2">
            <button
              type="button"
              className="btn btn-xs btn-sm btn-success"
              data-add="rule"
            >
              <i className="[object Object]"></i> Agregar Regla
            </button>

            <button
              type="button"
              className="btn btn-xs btn-sm btn-success"
              data-add="group"
            >
              <FaPlus /> Agregar Grupo 33
            </button>

            <button
              type="button"
              className="btn btn-xs btn-danger"
              data-delete="group"
            >
              <i className="glyphicon glyphicon-remove"></i> Eliminar
            </button>
          </div>
          {/*  <div className="btn-group group-conditions">
            <label className="btn btn-xs btn-primary disabled active">
              <input
                type="radio"
                name="builder-widgets_group_2_cond"
                value="AND"
                disabled=""
              />{" "}
              AND
            </label>

            <label className="btn btn-xs btn-primary disabled">
              <input
                type="radio"
                name="builder-widgets_group_2_cond"
                value="OR"
                disabled=""
              />{" "}
              OR
            </label>
          </div>*/}

          <div className="error-container" data-toggle="tooltip">
            <i className="glyphicon glyphicon-warning-sign"></i>
          </div>
        </div>
        <div className="rules-group-body">
          <div className="rules-list d-flex gap-2">
            <div
              id="builder-widgets_rule_2"
              className="rule-container  d-flex flex-row gap-2"
            >
              <div className="rule-header ">
                <div className="btn-group pull-right rule-actions">
                  <button
                    type="button"
                    className="btn btn-xs btn-sm btn-danger"
                    data-delete="rule"
                  >
                    <i className="glyphicon glyphicon-remove"></i> Borrar
                  </button>
                </div>
              </div>

              <div className="error-container" data-toggle="tooltip">
                <i className="glyphicon glyphicon-warning-sign"></i>
              </div>

              <div className="rule-filter-container">
                <select
                  className="form-control"
                  name="builder-widgets_rule_2_filter"
                >
                  <option value="-1">------</option>

                  <option value="date">Datepicker</option>

                  <option value="rate">Slider</option>

                  <option value="category">Selectize</option>

                  <option value="coord">Coordinates</option>
                </select>
              </div>
              <div className="rule-operator-container"></div>
              <div className="rule-value-container"></div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className={`d-flex items-center space-x-4 py-3 px-4 bg-gray-50 border-b align-items-center border border-1 border-primary ${className}`}
    >
      {/* Field Selector */}
      <div className="d-flex gap-4 flex-row align-items-center ">
        <div>
          <select
            className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
            value={clause.field.name}
            onChange={handleFieldChange}
          >
            <optgroup>
              <option value="" disabled>
                Selecciona Campo
              </option>
              {/*availableFields.map((field) => (
              <option key={field} value={field}>
                {field}
              </option>
            ))*/}
              {RowField.map((field) => (
                <option key={field.key} value={field.name}>
                  {field.name}
                </option>
              ))}
            </optgroup>
          </select>
        </div>

        {/* Operator Selector */}
        <div
          className="d-flex  align-items-center"
          style={{ alignItems: "center" }}
        >
          <select
            className="border border-gray-300 p-2 w-full rounded focus:ring-blue-500 focus:border-blue-500"
            value={clause.operator}
            onChange={handleOperatorChange}
          >
            <optgroup>
              {operators.map((op) => (
                <option key={op} value={op}>
                  {op}
                </option>
              ))}
            </optgroup>
          </select>
        </div>

        {/* Value Input */}
        <div>{renderInput(clause.value)}</div>
      </div>

      <span style={{ flex: "1" }}></span>

      {/* Remove Button */}
      <button
        onClick={() => onRemove(id)}
        className="p-2 bg-red-500 text-white rounded hover:bg-red-600 transition btn btn-primary"
        aria-label={`Remove clause for ${clause.field}`}
      >
        &times; Eliminar
      </button>
    </div>
  );
};

// ===============================
// MAIN BUILDER COMPONENT: QueryBuilder
// Manages the state array and orchestrates all clauses.
// ===============================
const QueryBuilder1 = ({ className }) => {
  const [niveles, setNiveles] = useState(null);
  const [asociados, setAsociados] = useState([]);
  const [metodosDePago, setMetodosDePago] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [enableAgregar, setEnableAgregar] = useState(true);

  // State holds an array of query objects (the clauses)
  const [clauses, setClauses] = useState([
    /*{
      id: 1,
      field: "",
      operator: "=",
      value: "",
      type: "",
      groupName: "Nivel",
    },*/
  ]);

  useEffect(() => {
    updateState();
  }, [clauses, niveles]);

  function updateState() {
    console.log(`clauses: ${clauses} - niveles: ${niveles}`);

    const agregar = true; //clauses?.length < niveles?.length;

    console.log(
      `clauses LEN: ${clauses?.length} - niveles LEN: ${niveles?.length}`,
    );

    setEnableAgregar(agregar);
  }

  // 1. Handler for adding a new empty clause row
  const addClause = () => {
    setClauses([
      ...clauses,
      { id: getNextId(), field: "", operator: "=", value: "", type: "" },
    ]);
  };

  // 1a. Handler for adding a new empty clause row
  const addGroupClause = (
    level = LEVEL.ZERO,
    newId = getNextId(),
    initialClauses = null,
  ) => {
    //  const level = clauses.length === 0 ? LEVEL.ZERO : LEVEL.FIRST;

    const newInitialClauses =
      initialClauses == null
        ? [
            {
              type: "rule",
              operator: "=",
              field: RowField.Nivel.key,
              fieldVisible: false,
            },
          ]
        : initialClauses;
    setClauses([
      ...clauses,
      {
        id: newId,
        field: "",
        operator: "=",
        value: "",
        type: "group",
        level: level,
        enableAgregar: true,
        initialClauses: newInitialClauses,
        showAgregarRule: false,
        showAgregarGrupo: true,
      },
    ]);
  };

  const updateGroupClause = (id, field, value) => {
    const clause = clauses.find((e) => e.id === id);
    if (clause == null) return;

    clause.groupName = value;
    setClauses([...clauses]);
  };

  const updateAgregarGrupo = (id, enableAgregarGrupo) => {
    const clause = clauses.find((e) => e.id === id);
    if (clause == null) return;

    clause.enableAgregar = enableAgregarGrupo;
    setClauses([...clauses]);
  };

  // 2. Generic state updater function (Passed down to QueryRow)
  const updateClauseState = (id, key, newValue) => {
    setClauses((prevClauses) =>
      prevClauses.map((clause) => {
        if (clause.id === id) {
          return { ...clause, [key]: newValue };
        }
        return clause;
      }),
    );
  };

  // 3. Handler for removing a specific clause row
  const removeClause = (idToRemove) => {
    setClauses((prevClauses) =>
      prevClauses.filter((clause) => clause.id !== idToRemove),
    );
  };

  // --- Final Output Rendering Logic ---
  const handleBuildQuery = () => {
    console.log("--- Query Built Successfully! ---");

    if (clauses.length === 0) {
      alert("Please add at least one condition.");
      return;
    }

    const queryParts = clauses
      // Filter out any rows that aren't properly filled
      .filter((clause) => clause.field && clause.operator && clause.value);

    if (queryParts.length === 0) {
      alert("Please fill in all criteria.");
      return;
    }

    const finalQuery = queryParts
      .map((clause) => `${clause.field} ${clause.operator} '${clause.value}'`)
      .join(" AND ");

    console.log(`SQL Query Result: SELECT * FROM table WHERE ${finalQuery};`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (resetPageNumber = true) => {
    setIsLoading(true);
    /*
    const payload = { asociadoId: 212 };
    const responseComisiones = await api
      .searchComisiones(payload)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoading(false);
      });*/

    const responseComisiones = await api.comisiones().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseComisiones) return;

    let clauses2 = buildGraph2(responseComisiones.data);
    setQuery(clauses2.length > 0 ? clauses2[0] : {});

    let clauses = buildGraph(responseComisiones.data);

    setClauses(clauses);
    //
    //addGroupClause(LEVEL.ZERO, group.id, group.childs);

    const responseNiveles = await api.niveles().catch((error) => {
      toast.error("Error al pedir Niveles.");
      setIsLoading(false);
    });

    if (!responseNiveles) return;

    const autoNiveles = responseNiveles.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });

    setNiveles(autoNiveles);

    const responseMetodoDePago = await api.metodosDePago().catch((error) => {
      toast.error("Error al pedir Forma Pagos.");
      setIsLoading(false);
    });

    if (!responseMetodoDePago) return;

    const autoMetodosDePago = responseMetodoDePago.data.map((item) => {
      return { id: item.id, nombre: item.nombre };
    });

    setMetodosDePago(autoMetodosDePago);
    //
    const response = await api
      .searchAsociados({ isActivo: true, page: 1, pageSize: "350" })
      .catch((e) => {
        toast.error("Error al pedir asociados.");
      });
    if (!response) return;

    const autoAsociados = response.data.subset.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);

    //

    /*let criteria = searchCriteria;
    if (resetPageNumber) {
      /// reset pag info
      store.pagingInfoRef.resetPageInfo();
    }

    //pagingInfoRef.current.resetPageInfo();

    criteria = store.pagingInfoRef.buildFetch(criteria);
    //criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);*/
  };

  function buildGraph2(datas) {
    const clauses = datas.map((data) => {
      const deserializeItem = (item) => {
        if (item == null) return null;

        // if (clause.type !== "group") return serial;

        let valueId = Number.parseInt(item.id);
        if (
          item["$type"] === "ComisionGrupoDto"
          // || (item["$type"] == null && item.childs)
        ) {
          const group = {
            id: item.id,
            combinator: item.combinator,
            rules: item.childs.map((e) => deserializeItem(e)),
          };

          return group;
        }

        let serial = {};
        if (item["$type"] === "ComisionNivelDto") {
          serial = {
            id: item.id,
            field: "niveles",
            operator: item.operator,
            valueSource: "value",
            value: {
              nivelId: item.nivelId,
              porcentaje: item.porcentaje,
            },
          };
        } else if (item["$type"] === "ComisionMetodoDePagoDto") {
          serial = {
            id: item.id,
            field: "metodosdepago",
            operator: item.operator,
            valueSource: "value",
            value: {
              metodoDePagoId: item.metodoDePagoId,
              porcentaje: item.porcentaje,
            },
          };
        } else if (item["$type"] === "ComisionAsociadoDto") {
          serial = {
            id: item.id,
            field: "asociados",
            operator: item.operator,
            valueSource: "value",
            value: {
              asociadoId: item.asociadoId,
              porcentaje: item.porcentaje,
            },
          };
        }

        return serial;
      };

      /* const deserializeChildren = (children) => {
        if (children == null) return null;
        return children.map((child) => {
          console.log("---");
          return deserializeItem(child);
        });
      };*/

      let clauseSerial = deserializeItem(data);

      return clauseSerial;
    });

    return clauses;
  }

  function buildGraph(datas) {
    const clauses = datas.map((data) => {
      const deserializeItem = (item) => {
        if (item == null) return null;

        let serial = {};
        // if (clause.type !== "group") return serial;

        let valueId = Number.parseInt(item.id);
        if (
          item["$type"] === "ComisionGrupoDto" ||
          (item["$type"] == null && item.childs)
        ) {
          //obtener el primer elemento y guardar su tipo como nomnbre del grupo
          const newInitialClauses = serializeChildren(item.childs);
          const groupName =
            newInitialClauses?.length > 0 ? newInitialClauses[0].field : "-";
          serial = {
            type: "group",
            id: valueId,
            activo: true,
            field: "",
            showAgregarGrupo: true,
            showAgregarRule: true,
            value: "",
            groupName: groupName,
            initialClauses: newInitialClauses,
            insideGroup: newInitialClauses,
          };
          return serial;
        }

        const deSerializeItem = deserializeItem(item.group);
        const deSerializeGroup = deSerializeItem ? [deSerializeItem] : null;

        if (item["$type"] === "ComisionNivelDto") {
          serial = {
            id: valueId,
            type: "rule",
            field: RowField.Nivel.key,
            activo: true,
            initialClauses: deSerializeGroup,
            valueId: item.nivelId,
            porcentaje: item.porcentaje,
          };
        } else if (item["$type"] === "ComisionAsociadoDto") {
          serial = {
            id: valueId,
            type: "rule",
            field: RowField.Asociado.key,
            activo: true,
            //initialClauses: serializeChildren(item.childs),
            //insideGroup: deserializeItem(item.group),
            initialClauses: deSerializeGroup,
            valueId: item.asociadoId,
            asociadoSelected: item.asociadoId,
            porcentaje: item.porcentaje,
          };
        } else if (item["$type"] === "ComisionMetodoDePagoDto") {
          serial = {
            id: valueId,
            type: "rule",
            field: RowField.MetodoDePago.key,
            activo: true,
            initialClauses: deSerializeGroup,
            valueId: item.metodoDePagoId,
            porcentaje: item.porcentaje,
          };
        }

        return serial;
      };

      const serializeChildren = (children) => {
        if (children == null) return null;
        return children.map((child) => {
          console.log("---");
          return deserializeItem(child);
        });
      };

      let clauseSerial = deserializeItem(data);

      return clauseSerial;
    });

    return clauses;
  }

  function buildChild(child, level) {
    let field = RowField.Nivel.key;
    let valueId = null;
    let type = child["$type"];
    let newLevel = level + 1;
    let porcentaje = child.porcentaje;

    if (type === "ComisionGrupoDto") {
      return buildGroup(child, newLevel);
    } else if (type === "ComisionAsociadoDto") {
      field = RowField.Asociado.key;
      valueId = child.asociadoId;
    } else if (type === "ComisionFormaPagoDto") {
      field = RowField.MetodoDePago.key;
      valueId = child.metodoPagoId;
    } else if (type === "ComisionNivelDto") {
      field = RowField.Nivel.key;
      valueId = child.nivelId;
    }

    /*if (clauses.length === 1) {
      key = RowField.Asociado.key;
      name = RowField.Asociado.name;
      enableAgregar = true;
    } else if (clauses.length === 2) {
      key = RowField.FormaPago.key;
      name = RowField.FormaPago.name;
    }*/

    return {
      type: "rule",
      operator: "=",
      field: field,
      valueId: valueId,
      valueDescuento: porcentaje,
    };
  }

  function buildGroup(group, level) {
    let newInitialClauses = group.childs.map((child) =>
      buildChild(child, level),
    );

    return {
      id: group.id,
      field: "",
      operator: "=",
      value: "",
      type: "group",
      level: level,
      enableAgregar: true,
      initialClauses: newInitialClauses,
      showAgregarRule: true,
      showAgregarGrupo: true,
    };
  }

  const showAgregar = enableAgregar ? "" : "disabled";

  const initialQuery = {
    combinator: "and",
    rules: [],
  };

  /*
  const initialQuery = {
    combinator: "or",
    rules: [
      {
        field: "metodosdepago",
        operator: "=",
        // "valueSource": "value",
        value: {
          actualValue: "contado_mercadopago",
          x: 10,
          y: 20,
          z: 30,
          porcentaje: 10,
        },
      },
    ],
    id: "1cb8b9fe-e8f1-40a3-8f11-b7265144f9f7",
  };
  */

  // Sets a global default fallback value for all newly created rules
  const getDefaultValue = (rule) => {
    /*if (rule.field === "age") return 18;
    return "Default Text";*/

    return {
      // actualValue: "3",
      //metodPago: "contado_mercadopago",
      //x: 10,
      //y: 20,
      // z: 30,
      porcentaje: 21,
    };
  };

  const [query, setQuery] = useState(initialQuery);

  //----

  const onAddRule = (rule, _pP, _q, context) => ({
    ...rule,
    context,
    field: fieldsGO.find((optGroup) => optGroup.label === context).options[0]
      .name,
  });

  //---
  const getMatchModes = (field, misc) => {
    // Return true to enable all match modes for any field
    if (field === "flexibleArray") return true;

    // Return specific match modes based on field type
    if (misc.fieldData.datatype === "array") {
      return ["all", "some", "none"];
    }

    // Return false or undefined to disable subqueries for this field
    return false;
  };
  //

  // 1. Define the custom wrapper for handling subqueries
  const CustomSubQueryEngine = ({ rule, path, actions, schema }) => {
    // Check if subproperties exist for the current targeted path
    const hasSubProperties = schema.fields.find(
      (f) => f.name === rule.field,
    )?.subproperties;

    if (!hasSubProperties) return null;

    return (
      <div
        className="custom-subquery-wrapper"
        style={{ paddingLeft: "20px", borderLeft: "2px solid #ccc" }}
      >
        <span>Nested Attributes Evaluation:</span>
        {/* Custom dropdowns, inputs, or child builders map here */}
      </div>
    );
  };

  const [queryESE, setQueryESE] = useState({
    combinator: "and",
    rules: [
      {
        field: "subquery_field",
        operator: "=",
        value: "main_query_target",
        ruleData: { afterValueParam: "sub_query_modifier" },
      },
    ],
  });
  //---

  //----
  const [queryOXXO, setQueryOXXO] = useState({
    combinator: "and",
    rules: [
      {
        field: "subquery_group",
        operator: "=",
        value: "active_users",
        // Initialize the custom data structure
        ruleData: { subQueryInputVal: "limit_10" },
      },
    ],
  });

  const [productos, setProductos] = useState([]);

  return (
    <div
      className={`p-6 max-w-4xl mx-auto bg-white shadow-2xl rounded-lg ${className}`}
    >
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Comisiones
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="d-flex">
              <div className="btn-group pull-right group-actions">
                <button
                  type="button"
                  className={`btn btn-xs btn-sm btn-primary ${showAgregar}`}
                  data-add="group"
                  onClick={async () => {
                    console.log("wss " + query);
                    // addGroupClause(LEVEL.ZERO);

                    const serializeItem = (item) => {
                      if (item == null) return null;

                      /*
                        combinator: "and"​
                        id: "205360fc-87e8-4984-8fa4-417e22961dc3",
                        "rules": [
                            {
                            "id": "69690aa5-7cb5-48b8-993a-1123a3575247",
                            "field": "niveles",
                            "operator": "=",
                            "valueSource": "value",
                            "value": {
                                "actualValue": "3",
                                "metodPago": "contado_mercadopago",
                                "x": 10,
                                "y": 20,
                                "z": 30,
                                "porcentaje": 25
                            }
                            },
                        ]
                        */
                      let serial = {};
                      //const groups = item.newGroup || item.initialClauses;
                      if (item.rules != null) {
                        serial = {
                          type: "ComisionGrupoInput",
                          activo: true,
                          childs: serializeChildren(item.rules),
                          combinator: item.combinator,
                        };

                        return serial;
                      }

                      let { porcentaje, nivelId, metodoDePagoId, asociadoId } =
                        item.value;

                      porcentaje = Number.parseInt(porcentaje);
                      nivelId = Number.parseInt(nivelId);
                      metodoDePagoId = Number.parseInt(metodoDePagoId);
                      asociadoId = Number.parseInt(asociadoId);

                      if (item.field === "metodosdepago") {
                        serial = {
                          type: "ComisionMetodoDePagoInput",
                          activo: true,
                          //childs: serializeChildren(groups),
                          //group: serializeItem(group),
                          metodoDePagoId: metodoDePagoId,
                          porcentaje: porcentaje,
                        };
                      } else if (item.field === "niveles") {
                        serial = {
                          type: "ComisionNivelInput",
                          activo: true,
                          //childs: serializeChildren(groups),
                          //group: serializeItem(group),
                          nivelId: nivelId,
                          porcentaje: porcentaje,
                        };
                      } else if (item.field === "asociados") {
                        /*
                      - debe de estar seleccionado un asociadoId sino ignorar
                      */
                        if (asociadoId == null) {
                          return null;
                        }

                        serial = {
                          type: "ComisionAsociadoInput",
                          activo: true,
                          //childs: serializeChildren(groups),
                          //group: serializeItem(group),
                          asociadoId: asociadoId,
                          porcentaje: porcentaje,
                        };
                      }

                      serial.operator = item.operator;

                      return serial;
                    };

                    const serializeChildren = (children) => {
                      if (children == null) return null;
                      return children.map((child) => {
                        console.log("---");
                        return serializeItem(child);
                      });
                    };

                    let payload = serializeItem(query);
                    payload = [payload];

                    const response = await api
                      .createComisiones(payload)
                      .catch((e) => {
                        toast.error("Error al pedir Comisiones.");
                      });

                    if (!response) return;
                  }}
                >
                  <IoSaveOutline /> Guardar
                </button>
              </div>
              <div className="flex-grow-1"></div>
              <div className="btn-group pull-right group-actions"></div>
            </div>
            <div className="accordion-body">
              <QueryBuilder
                fields={fieldsComision}
                query={query}
                onQueryChange={setQuery}
                translations={esTranslations}
                showNotToggle
                controlClassnames={{ queryBuilder: "queryBuilder-branches" }}
                controlElements={{
                  //RuleComponentsWithSubQuery: CustomSubQueryEngine
                  valueEditor: CustomValueEditorSample, // CustomValueEditor,
                  //ruleGroupHeaderElements: CustomRuleGroupHeader // Inject custom header here
                  // addRuleAction: CustomAddRuleButton,
                  // Replaces or augments the default layout element
                  // **ruleGroupHeaderElements: CustomGroupHeaderDEMO, //CustomGroupHeaderDECA, //CustomGroupHeaderDEMO,
                  //a
                  // ruleGroupBodyElements: CustomGroupBody,

                  // rule: CustomRule1, // Overrides the default Rule layout

                  //rule: CustomRuleWithSubQueryInput
                }}
                getMatchModes={getMatchModes}
                getDefaultValue={getDefaultValue}
              />
              <pre>{JSON.stringify(query, null, 2)}</pre>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Ignorados
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <QueryBuilder
                fields={fieldsIgnorar}
                query={query}
                onQueryChange={setQuery}
                translations={esTranslations}
                controlClassnames={{ queryBuilder: "queryBuilder-branches" }}
                controlElements={{
                  //RuleComponentsWithSubQuery: CustomSubQueryEngine
                  valueEditor: CustomValueEditorSample, // CustomValueEditor,
                  //ruleGroupHeaderElements: CustomRuleGroupHeader // Inject custom header here
                  // addRuleAction: CustomAddRuleButton,
                  // Replaces or augments the default layout element
                  // **ruleGroupHeaderElements: CustomGroupHeaderDEMO, //CustomGroupHeaderDECA, //CustomGroupHeaderDEMO,
                  //a
                  // ruleGroupBodyElements: CustomGroupBody,

                  // rule: CustomRule1, // Overrides the default Rule layout

                  //rule: CustomRuleWithSubQueryInput
                }}
                getMatchModes={getMatchModes}
              />
              <pre>{JSON.stringify(query, null, 2)}</pre>
            </div>
          </div>
        </div>
      </div>
      Da Click en "Agregar Grupo" para empezar.
      {/*  <h1 className="text-3xl font-bold mb-6 text-gray-800 border-b pb-2">
        Database Query Builder ⚙️
      </h1>

      {/* Controls * /}
      <div
        className="d-flex justify-between items-center mt-8 pt-6 border-t gap-2"
        style={{ borderStyle: "solid", borderWidth: "1px" }}
      >
        {/* Add Button * /}
        <button
          onClick={addClause}
          className="px-5 py-2 bg-blue-600 text-white font-semibold rounded shadow hover:bg-blue-700 transition duration-150 btn btn-primary"
        >
          + Agregar Condición
        </button>

        {/* Add Button * /}
        <button
          onClick={addGroupClause}
          className="px-5 py-2 bg-blue-600 text-white font-semibold rounded shadow hover:bg-blue-700 transition duration-150 btn btn-primary"
        >
          + Agregar Grupo
        </button>

        {/* Build Button * /}
        <button
          onClick={handleBuildQuery}
          className="px-6 py-3 bg-green-600 text-white font-bold rounded shadow-lg hover:bg-green-700 transition duration-150 btn btn-primary"
        >
          Build Query (View Console)
        </button>
      </div>*/}
      <div className="d-flex">
        <div className="btn-group pull-right group-actions">
          <button
            type="button"
            className={`btn btn-xs btn-sm btn-primary ${showAgregar}`}
            data-add="group"
            onClick={async () => {
              console.log("wss");
              // addGroupClause(LEVEL.ZERO);

              const payload = clauses.map((clause) => {
                const serializeItem = (item) => {
                  if (item == null) return null;
                  let serial = {};
                  // if (clause.type !== "group") return serial;
                  const groups = item.newGroup || item.initialClauses;
                  if (item.type === "group") {
                    serial = {
                      type: "ComisionGrupoInput",
                      activo: true,
                      childs: serializeChildren(groups),
                    };
                  } else if (item.type === "rule") {
                    const group = item.insideGroup;
                    //const groups = item.newGroup || item.initialClauses;
                    let valueId = Number.parseInt(item.valueId);
                    if (item.field === RowField.Nivel.key) {
                      serial = {
                        type: "ComisionNivelInput",
                        activo: true,
                        childs: serializeChildren(groups),
                        group: serializeItem(group),
                        nivelId: valueId,
                        porcentaje: item.valueDescuento,
                      };
                    } else if (item.field === RowField.Asociado.key) {
                      serial = {
                        type: "ComisionAsociadoInput",
                        activo: true,
                        childs: serializeChildren(groups),
                        asociadoId: valueId,
                        porcentaje: item.valueDescuento,
                        group: serializeItem(group),
                      };
                    } else if (item.field === RowField.MetodoDePago.key) {
                      serial = {
                        type: "ComisionMetodoDePagoInput",
                        activo: true,
                        childs: serializeChildren(groups),
                        group: serializeItem(group),
                        metodoDePagoId: valueId,
                        porcentaje: item.valueDescuento,
                      };
                    }
                  }

                  return serial;
                };

                const serializeChildren = (children) => {
                  if (children == null) return null;
                  return children.map((child) => {
                    console.log("---");
                    return serializeItem(child);
                  });
                };

                let clauseSerial = serializeItem(clause);

                return clauseSerial;
              });

              const response = await api
                .createComisiones(payload)
                .catch((e) => {
                  toast.error("Error al pedir Comisiones.");
                });

              /*  const response = await api
                .createComisiones({
                  type: "ComisionGrupoInput",
                  activo: true,
                  childs: [
                    {
                      type: "ComisionNivelInput",
                      nivelId: 1,
                      porcentaje: 15,
                      activo: true,
                    },
                    {
                      type: "ComisionGrupoInput",
                      activo: true,
                      childs: [
                        {
                          type: "ComisionAsociadoInput",
                          nivelId: 1,
                          porcentaje: 15,
                          activo: true,
                          asociadoId: 121,
                          group: {
                            type: "ComisionGrupoInput",
                            activo: true,
                            childs: [
                              {
                                type: "ComisionMetodoDePagoInput",
                                metodoDePagoId: 1,
                                porcentaje: 10,
                                activo: true,
                              },
                              {
                                type: "ComisionMetodoDePagoInput",
                                metodoDePagoId: 2,
                                porcentaje: 10,
                                activo: true,
                              },
                              {
                                type: "ComisionMetodoDePagoInput",
                                metodoDePagoId: 3,
                                porcentaje: 10,
                                activo: true,
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                })
                .catch((e) => {
                  toast.error("Error al pedir asociados.");
                });*/
              if (!response) return;
            }}
          >
            <IoSaveOutline /> Guardar
          </button>
        </div>
        <div className="flex-grow-1"></div>
        <div className="btn-group pull-right group-actions">
          <button
            type="button"
            className={`btn btn-xs btn-sm btn-success ${showAgregar}`}
            data-add="group"
            onClick={() => {
              console.log("wss");
              addGroupClause(LEVEL.ZERO);
            }}
          >
            <FaPlus /> Agregar Grupo
          </button>
        </div>
      </div>
      {/* Clause Display Area */}
      <div className={`space-y-2 mb-6 query-builder`}>
        {clauses.length > 0 ? (
          clauses.map((clause) => (
            <QueryGroup
              key={clause.id}
              id={clause.id}
              clause={clause}
              onUpdate={updateGroupClause}
              onUpdateAgregarGrupo={updateAgregarGrupo}
              onRemove={removeClause}
              onChange={() => {
                console.log("wss");
                addGroupClause(LEVEL.FIRST);
              }}
              className={`rules-group-container`}
              asociados={asociados}
              niveles={niveles}
              metodosDePago={metodosDePago}
              groupName={clause.groupName}
              level={clause.level}
              initialClauses={clause.initialClauses}
              enableAgregar={clause.enableAgregar}
              showAgregarGrupo={clause.showAgregarGrupo}
              showAgregarRule={clause.showAgregarRule}
              onNewGroup={(newClauses) => {
                clause.newGroup = newClauses;
              }}
            />
          ))
        ) : (
          <div className="p-6 text-center border-2 border-dashed border-gray-200 rounded">
            Da Click en "Agregar Grupo" para empezar.
          </div>
        )}
      </div>
    </div>
  );
};

export default QueryBuilder1;
